export default __webpack_public_path__ + "static/media/6.863a73a0.svg";